"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPRPTextComparisonComponentParameters = void 0;
exports.UserPRPTextComparisonComponentParameters = [
    {
        id: 'model_a_name',
        label: 'Model A Name',
        description: 'Input Param - Name of the first model',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'model_a_response',
        label: 'Model A Response',
        description: 'Input Param - Response text from the first model',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'model_b_name',
        label: 'Model B Name',
        description: 'Input Param - Name of the second model',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'model_b_response',
        label: 'Model B Response',
        description: 'Input Param - Response text from the second model',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'randomize_order',
        label: 'Randomize Order',
        description: 'Input Param - Randomly swap which model appears in position A vs B',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'anonymize_model_names',
        label: 'Anonymize Model Names',
        description: 'Input Param - Show generic/anonymous names instead of actual model names',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'selected_model',
        label: 'Selected Model',
        description: 'Output Param - The actual model name that was selected by the user',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
];
//# sourceMappingURL=UserPRPTextComparisonComponent.js.map